import {
  QuotationOutboxDto,
  QuotationOutboxState,
  SaveQuotationResponseCommandRequest,
  SaveQuotationResponseCommandResponse,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { GetContext } from 'store/storeUtils'
import { QuotationOutboxController } from '../QuotationOutboxController'

export class ProjectQuotationsController extends QuotationOutboxController {
  private readonly projectId: string

  constructor() {
    super()
    this.projectId = GetContext().projectId
  }

  public async GetQuotationResponse(): Promise<QuotationOutboxDto> {
    const existingResponse = (await this.list())
      .filter((quotation) => quotation.sellerProjectId === this.projectId)
      .sort(
        (left, right) => {
          const statePriority =
            Number(left.state === QuotationOutboxState.Draft) -
            Number(right.state === QuotationOutboxState.Draft)

          return (
            statePriority ||
            new Date(right.dateChanged ?? right.dateCreated ?? 0).getTime() -
              new Date(left.dateChanged ?? left.dateCreated ?? 0).getTime()
          )
        },
      )[0]

    if (existingResponse) {
      return existingResponse
    }

    const draft = await this.draft(this.projectId)
    return {
      id: draft.quotation.id,
      sellerProjectId: this.projectId,
      state: QuotationOutboxState.Draft,
      document: draft.quotation,
    }
  }

  public SaveQuotationResponse(
    request: SaveQuotationResponseCommandRequest,
  ): Promise<SaveQuotationResponseCommandResponse> {
    return this.save(request.quotationResponseId, request)
  }

  public SendQuotationResponseToBuyer(quotationId: string): Promise<void> {
    return this.send(quotationId, this.projectId)
  }

  public DeleteQuotationResponse(quotationId: string): Promise<void> {
    return this.delete(quotationId)
  }
}
